import { Flex } from 'antd'
import { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import FormattedCurrency from 'shared/components/FormattedCurrency'
import { DEFAULT_FIAT_PRECISION } from 'shared/constants'
import s from './s.module.css'
import { lang } from './lang.ts'

interface Props {
  current?: string
  target?: string
  currency: string
}

function ProgressBar({ current, target, currency }: Props) {
  const [currentWidth, setCurrentWidth] = useState(0)

  useEffect(() => {
    if (current != null && target != null && !isNaN(Number(current) / Number(target))) {
      const percentWidth = Math.floor((Number(current) / Number(target)) * 100)
      setCurrentWidth(percentWidth > 100 ? 100 : percentWidth)
    }
  }, [current, target])

  return (
    <Flex vertical gap={8}>
      <div className={s.bar}>
        <div
          className={s.progress}
          style={{ width: `${currentWidth}%`, transitionDuration: `${currentWidth / 100}s` }}
        />
      </div>
      <Flex justify="space-between" gap={4} wrap="wrap">
        {currency && (
          <Text type="primary" fontType="title" fontSize={16}>
            <FormattedCurrency currency={currency} value={current} maxPrecision={DEFAULT_FIAT_PRECISION} />
          </Text>
        )}
        <Flex gap={4} wrap="nowrap">
          <Text type="tertiary" fontType="title" fontSize={16}>
            <FormattedMessage {...lang.out} />
          </Text>
          {currency && (
            <Text type="primary" fontType="title" fontSize={16}>
              <FormattedCurrency currency={currency} value={target} maxPrecision={DEFAULT_FIAT_PRECISION} />
            </Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}
export default ProgressBar
